import { Reducer } from "@reduxjs/toolkit";
import dayjs from "dayjs";
import { EstadoRequisicao } from "store/types";
import { ResponseError } from "view/component/MensagensErroServidor/ErroServidor.utils";
import { ItemListaNotificacoes } from "../../model/ItemListaNotificacoes";
import { NotificacoesAction } from "./Notificacoes.action";
import { NotificacaoActionTypes, NotificacaoState } from "./Notificacoes.type";
import { v4 as uuidv4 } from 'uuid';


const estadoInicial: NotificacaoState = {
  sse: {
    estado: EstadoRequisicao.OCIOSO,
  },
  notificacaoAExibir: undefined,
  lista: {
    estado: EstadoRequisicao.OCIOSO,
    erros: undefined,
    elementos: [],
    totalNaoLidas: 0,
  },
  itemVisualizado: {
    item: undefined,
    estado: EstadoRequisicao.OCIOSO
  }
}

export const notificacaoReducer: Reducer<NotificacaoState, NotificacaoActionTypes> = (state = estadoInicial, action): NotificacaoState => {
  // SSE
  if (NotificacoesAction.sse._iniciarConexao.match(action)) {
    return {
      ...state,
      sse: {
        ...state.sse,
        estado: EstadoRequisicao.CARREGANDO
      }
    }

  } else if (NotificacoesAction.sse._definirComoConectado.match(action)) {
    return {
      ...state,
      sse: {
        ...state.sse,
        estado: EstadoRequisicao.BEM_SUCEDIDO
      }
    }

  } else if (NotificacoesAction.sse._adicionarNotificacao.match(action)) {
    const notificacoes = state.lista.elementos;
    notificacoes.unshift(action.payload);

    return {
      ...state,
      notificacaoAExibir: {
        tipo: "notificacao",
        aparencia: "normal",
        notificacao: action.payload,
      },
      lista: {
        ...state.lista,
        elementos: [action.payload, ...state.lista.elementos],
        totalNaoLidas: state.lista.totalNaoLidas + 1,
      }
    }

  // Lista
  } else if (NotificacoesAction.lista.iniciar.pending.match(action)) {
    return {
      ...state,
      lista: {
        ...state.lista,
        estado: EstadoRequisicao.CARREGANDO
      }
    }

  } else if (NotificacoesAction.lista.iniciar.fulfilled.match(action)) {
    const elementos = [...state.lista.elementos, ...action.payload.content];

    return {
      ...state,
      lista: {
        ...state.lista,
        estado: EstadoRequisicao.BEM_SUCEDIDO,
        elementos: elementos,
        totalNaoLidas: elementos.filter(it => !it.visualizado).length,
      }
    }
  } else if (NotificacoesAction.lista.iniciar.rejected.match(action)) {
    return {
      ...state,
      lista: {
        ...state.lista,
        estado: EstadoRequisicao.FALHOU,
        erros: action.payload as ResponseError,
      }
    }
  // Item
  } else if (NotificacoesAction.lista._marcarComo.pending.match(action)) {
    const notificacao = action.meta.arg.item;
    notificacao.visualizado = !notificacao.visualizado;
    const add = notificacao.visualizado ? -1 : +1;

    return {
      ...state,
      lista: {
        ...state.lista,
        totalNaoLidas: state.lista.totalNaoLidas + add
      },

      itemVisualizado: {
        ...state.itemVisualizado,
        estado: EstadoRequisicao.CARREGANDO,
        item: action.payload
      }
    }
  } else if (NotificacoesAction.lista._marcarComo.fulfilled.match(action)) {
    return {
      ...state,
      itemVisualizado: {
        ...state.itemVisualizado,
        estado: EstadoRequisicao.BEM_SUCEDIDO,
        item: undefined
      }
    }
  }

  // Aviso
  if (NotificacoesAction.lista.exibirAlerta.match(action)) {
    const alerta: ItemListaNotificacoes = {
      sistema: "alerta-interno",
      id: uuidv4(),
      titulo: action.payload.titulo as any,
      mensagem: action.payload.mensagem as any,
      metadados: {},
      visualizado: false,
      dataNotificacao: dayjs(),
    }

    return {
      ...state,
      notificacaoAExibir: {
        tipo: "alerta",
        aparencia: "success",
        notificacao: alerta
      }
    }
  }

  return state;
}